export const DEFAULT_REFRESH = 60000;
export const FRANCETV_ENDPOINT_FN = (channel) => `/${channel}/metadata/`;
